import { stageAttendanceVideo, discardStagedVideo, resumeAttendanceVideos } from './attendanceVideoQueue'
import { apiClient } from './apiClient'

const key = uid => `atttrack_pending_punch_${uid}`
const read = uid => {
  try { return JSON.parse(localStorage.getItem(key(uid)) || 'null') } catch { return null }
}
const inflight = new Map()
async function deliver(uid, payload) {
  if (inflight.has(uid)) return inflight.get(uid)
  const request = apiClient.post('/v1/attendance-actions/punch', payload, {
    adapter: async config => {
      const response = await fetch(`${config.baseURL}${config.url}`, {
        method: 'POST', keepalive: true,
        headers: config.headers.toJSON(), body: config.data,
      })
      const data = await response.json()
      if (!response.ok) {
        const error = new Error(data.error || 'Attendance could not be saved.')
        error.status = response.status
        throw error
      }
      return { data, status: response.status, statusText: response.statusText, headers: {}, config }
    },
  }).then(response => {
    if (read(uid)?.id === payload.id) localStorage.removeItem(key(uid))
    return response.data.doc
  }).catch(error => {
    if (error.status >= 400 && error.status < 500 && ![401, 408, 429].includes(error.status)) {
      if (read(uid)?.id === payload.id) localStorage.removeItem(key(uid))
    }
    throw error
  }).finally(() => inflight.delete(uid))
  inflight.set(uid, request)
  return request
}
export async function resumePendingPunch(uid) {
  const pending = read(uid)
  if (!pending) return null
  return deliver(uid, pending)
}
export async function submitPunch(uid, payload, videoBlob = null) {
  const pending = read(uid)
  if (pending) {
    await deliver(uid, pending)
    throw new Error('Your previous attendance action was recovered. Check your status before another action.')
  }
  const request = { ...payload, id: crypto.randomUUID() }
  // Persist before sending; a lost response is retried using the same server ID.
  if (videoBlob) await stageAttendanceVideo(uid, request, videoBlob)
  try { localStorage.setItem(key(uid), JSON.stringify(request)) } catch (error) {
    if (videoBlob) await discardStagedVideo(request.id)
    throw error
  }
  if (videoBlob) void resumeAttendanceVideos(uid)
  try { return await deliver(uid, request) } catch (error) {
    if (read(uid)) throw new Error('Attendance is pending delivery. Reopen the app when connected to confirm it was saved.')
    throw error
  }
}
export const hasPendingPunch = uid => Boolean(read(uid))
